<div class="error-container">
  <div class="content-container">
    <p class="main-message">{{ authText }}</p>
    <div class="text-container">
      <p class="error-message">{{ errorMessage }}</p>
    </div>
    <p class="error-link">
      <a href="{{ errorLink }}" target="_blank">{{ errorLinkText }}</a>
    </p>
  </div>
</div>
